(ns teamoesterreich.store
  (:require [reagent.core :as r]
            [reagent.core :as reagent]
            [teamoesterreich.util.log :as log]))


(defonce empty-store {:site            :landing
                      :loadingFinished false
                      :loaded          {}

                      :lr-app-link     nil
                      :lr-sb-link      nil

                      :firebase-uid    nil
                      :connected       false

                      :messages        {}
                      :eventList       {}
                      :fakeIt          false
                      :profile-state   {}
                      :actual-location nil

                      :state           {
                                        :show-triggers []
                                        }
                      :home-target     :landing

                      :login-error     false
                      :load-error      false

                      })

(defonce app-state (reagent/atom empty-store))

(defn reset []
      (reset! app-state empty-store)
      )

(defn print-state []
      (log/out "Actual State:" (clj->js @app-state)))

;(reagent/cursor  app-state [:toe-map])

(aset js/window "getUserStoreAll" teamoesterreich.store/print-state)

(defn update-loading [& [comp]]

      (let [!loaded (r/cursor app-state [:loaded])
            !loadingFinished (r/cursor app-state [:loadingFinished])]

           (log/out "Loading check" (clj->js @!loaded) @!loadingFinished)

           (when comp (swap! !loaded assoc comp true))

           (if (and
                 @!loaded
                 (:user @!loaded)
                 (:auth @!loaded)
                 )
             (do
               (reset! !loadingFinished true))
             (log/out "Loading incomplete" (clj->js @!loaded))
             )))